import React, { useState, useEffect, useRef } from 'react';

function StudyTimer({ onTimeUpdate }) {
  const [isRunning, setIsRunning] = useState(false);
  const [time, setTime] = useState(0);
  const [showSettings, setShowSettings] = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (isRunning) {
      intervalRef.current = setInterval(() => {
        setTime(prevTime => {
          const newTime = prevTime + 1;
          if (onTimeUpdate) {
            onTimeUpdate(newTime);
          }
          return newTime;
        });
      }, 1000);
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isRunning, onTimeUpdate]);

  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    if (hours > 0) {
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }
    return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const handleStart = () => setIsRunning(true);
  const handlePause = () => setIsRunning(false);
  const handleReset = () => {
    setIsRunning(false);
    setTime(0);
    if (onTimeUpdate) {
      onTimeUpdate(0);
    }
  };

  return (
    <div className="study-timer">
      <div className="timer-display">
        <div className="timer-icon">⏱️</div>
        <div className="timer-text">{formatTime(time)}</div>
        <button
          className="timer-settings-btn"
          onClick={() => setShowSettings(!showSettings)}
          title="Timer settings"
        >
          ⚙️
        </button>
      </div>

      <div className="timer-controls">
        {!isRunning ? (
          <button className="btn btn-success" onClick={handleStart}>
            <span className="btn-icon">▶️</span>
            Start
          </button>
        ) : (
          <button className="btn btn-warning" onClick={handlePause}>
            <span className="btn-icon">⏸️</span>
            Pause
          </button>
        )}
        <button className="btn btn-secondary" onClick={handleReset}>
          <span className="btn-icon">🔄</span>
          Reset
        </button>
      </div>

      {showSettings && (
        <div className="timer-settings">
          <h4>Study Goals</h4>
          <div className="goal-options">
            <button className="goal-btn" onClick={() => setTime(15 * 60)}>15 min</button>
            <button className="goal-btn" onClick={() => setTime(30 * 60)}>30 min</button>
            <button className="goal-btn" onClick={() => setTime(60 * 60)}>1 hour</button>
            <button className="goal-btn" onClick={() => setTime(90 * 60)}>1.5 hours</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default StudyTimer;